import { createFileRoute } from '@tanstack/react-router';
import { SectorRotationPage } from '@/features/sector-rotation/SectorRotationPage';
import { isMarket, type Market } from '@/lib/market/types';

export const Route = createFileRoute('/$market/market/sector-rotation')({
  component: MarketSectorRotationRoute,
});

function MarketSectorRotationRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';

  return <SectorRotationPage market={market} />;
}
